<div class="search">
  <div class="search__form">
    <form [formGroup]="gamesSearch.searchForm">
      <app-form-input [control]="gamesSearch.searchForm.get('search')" [label]="'t.search' | translate">
        <div (click)="applySearchFilter()" [ngClass]="{'active': gamesSearch.searchStr}" class="icon-block">
          <i [ngClass]="{'active': gamesSearch.searchStr}" class="icon-arrow"></i>
        </div>
        <input
          (focusin)="gamesSearch.onFocus()"
          (keyup.enter)="applySearchFilter()"
          formControlName="search" type="text" class="input input--simple"
        >
      </app-form-input>
    </form>
  </div>
</div>
